import script from "./PublicFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicFooter.vue?vue&type=script&setup=true&lang=js"

import "./PublicFooter.vue?vue&type=style&index=0&id=125bf2d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125bf2d2"]])

export default __exports__